import { render, staticRenderFns } from "./UsuarioPerfil.vue?vue&type=template&id=147fd364"
import script from "./UsuarioPerfil.vue?vue&type=script&lang=js"
export * from "./UsuarioPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports